import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchLocationListResponse>}
 */
export function requestLocationList(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/location`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/location?${params}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function requestCreateLocation(data) {
 return fetch.post(`${BASE_URL}/api/app/location`, data)
}

export function requestupdateLocation(data) {
  const body = { ...data }
  delete body["_id"]
  return fetch.put(`${BASE_URL}/api/app/location/${data._id}`, body)
}

export function requestDeleteLocation(data) {
  const body = { ...data }
  delete body["_id"]
  return fetch.delete(`${BASE_URL}/api/app/location/${data._id}`, body)
}